import React from 'react'
import Navbar from '../inc/Navbar'
import LysorichSyrupphoto from "../images/Lysorich Syrup img.jpg";
import LysorichSyrupnew from "../images/Lysorich Syrup_2.png"
function LysorichSyrup() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <img src={LysorichSyrupphoto} className="d-block w-100" alt="LysorichSyrup" />
      <div className='LysorichSyrup'>
        <div className="album py-1">
          <div className="container">
            <center>
              <h2 className='mt-3'>Lysorich Syrup</h2>
              <p>Each 5ml contains: Lysine 375mg+Vitamin B1 1mg+Vitamin B6 0.75mg+ Vitamin B12 2.2mg+Elemental Zinc 10mg+Biotin 40 mcg</p>
            </center>
          </div>
        </div>
      </div>
      <b />

      <div className="album py-1">
        <div className="container">
          <center>
            <h1><b>Lysorich Syrup</b> Uses </h1>
          </center>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <img src={LysorichSyrupnew} className="img-fluid " alt="Lysorich Syrup" />

            </div>

            <div className="col-md-8">
              <br/>
              <br/>
              <h5 style={{color:"#0499a0"}} className='mb-0'><b>Appetite care taker</b></h5>
              <p><small>Not only increases the appetite, but it also helps stimulates digestive acid building and helps to build red blood cells</small></p>
               <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Immunity Booster</b></h5>
              <p><small>Not only increases the appetite, but it also helps stimulates digestive acid building and helps to build red blood cells</small></p>
               <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Anti-Oxidant</b></h5>
              <p><small>Lycopene Suppresses oxidative stress</small></p>
                      <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Increasing collagen formation</b></h5>
              <p><small>L-lysine promotes normal growth and development by increasing collagen formation</small></p>
                             <h5 style={{color:"#0499a0"}}  className='mb-0'><b>Nerve Protector</b></h5>
              <p><small>NB vitamins work to activate muscles and nervous functions.</small></p>
                             <h5 style={{color:"#0499a0"}}  className='mb-0'><b> Energy Booster</b></h5>
              <p><small>B Vitamins help the body to produce energy and form red blood cells</small></p>
            </div>
          </div>
          <br/>
          <br/>
          <br/>
          <div className='bg'>
            <br/>
          <center>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Vitamin B-Complex deficiency</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Low Appetite</p>

<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Oxidative Stress</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> General Disability & Convalescence</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Low HB</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Growth Phase</p>
<p className='mb-1'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg> Along with Antibiotics</p>
</center>
<br/>
</div>
        </div>
        </div>
        <br />
      </div>
      )
}

      export default LysorichSyrup